import { Injectable } from '@angular/core';

import { OberflaecheSeite, TarifierungProvider } from '@vhv/tarifrechner-common';


export interface IRateConfig {
    name: string;
    ivmnr: string;
    title: string;
    kWpMin: number;
    kWpMax: number;
    Versicherungssumme1: number;
    minBeitrag1: number;
    BeiSatz1: number;
    SelbstBeteiligung1: number;
    HaftZeit1: number;
    HaftZeitSelbstBeteiligung1: number;
}

type RateHandler = (rateConfigService: RateConfigService, tarifierungProvider: TarifierungProvider) => void;

export interface IRateHandlerCollection {
    [key: string]: RateHandler;
}

@Injectable({
    providedIn: 'root',
})
export class RateConfigService {
    private _vermittler: string = '022230-000';
    private config: IRateConfig;

    private oberflaecheSeiten: OberflaecheSeite[] = [];

    constructor() {
        this.loadConfig();
    }

    public get vermittler(): string {
        return this._vermittler;
    }

    public set vermittler(value: string) {
        this._vermittler = value;
    }

    public getkWpMin(): Promise<number> {
        return Promise.resolve(0);
    }

    public getkWpMax(): Promise<number> {
        return Promise.resolve(50);
    }

    public getVersicherungssumme1(): number {
        return this.config.Versicherungssumme1;
    }

    public getMinBeitrag1(): number {
        return this.config.minBeitrag1;
    }

    public getBeiSatz1(): number {
        return this.config.BeiSatz1;
    }

    public getSelbstBeteiligung1(): number {
        return this.config.SelbstBeteiligung1;
    }

    public getHaftZeit1(): number {
        return this.config.HaftZeit1;
    }

    public getHaftZeitSelbstBeteiligung1(): number {
        return this.config.HaftZeitSelbstBeteiligung1;
    }

    public getVermittlerName(): string {
        return this.config.name;
    }

    public getTariffTitle(): string {
        return this.config.title;
    }

    public getIVMNR(): string {
        return this.config.ivmnr;
    }

    private loadConfig() {
        try {
            this.config = require(`./config/${this.vermittler}/rate.config.json`);
        } catch (err) {
            console.warn(
                `Unable to load vermittler rate config. Used vermittler was ${
                    this.vermittler
                    }. Fall back to default from "022230-000"`,
            );

            this.config = require(`./config/022230-000/rate.config.json`);
        }
    }
}
